// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2jF1M","content":"LoadingAlert_content__1biyT"};